import React, { useState, useEffect } from 'react'
import parentStyles from 'srcReact/WorkplaceSettingsPage/styles.module.scss'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import SearchTextBox from 'srcReact/components/common2/SearchTextBox'
import OrderByDropdown from 'srcReact/components/common2/OrderByDropdown'

const Header = ({ searchText, setSearchText, setOrderby, orderByOptions, setPagination }) => {
  const { t } = useTranslation()

  const [showSearchPopup, setShowSearchPopup] = useState(false)
  const [selectedOrder, setSelectedOrder] = useState(orderByOptions[0])

  const handleSearchFocus = () => {
    setShowSearchPopup(true)
  }
  const handleSearchBlur = () => {
    setShowSearchPopup(false)
  }
  const handleSearchKeyDown = () => {
    setShowSearchPopup(false)
  }
  const handleOrderByChange = (order) => {
    setOrderby(order.value)
    setSelectedOrder(orderByOptions.find((o) => o.value === order.value))
  }
  const handleSearch = (searchValue) => {
    setSearchText(searchValue)
    setPagination({ nextOffset: 0, isPagination: false })
  }
  const isFocused = showSearchPopup || searchText?.length > 0

  return (
    <div className={styles.manageInvitesHeader}>
      <SearchTextBox
        id='memberSearch'
        value={searchText}
        {...(searchText?.length === 0 && { clear: true })}
        minimumSearchChar={1}
        size='large'
        iconPosition='start'
        placeholder={t('workplaceSettings.members.searchPlaceholder')}
        handleSearch={handleSearch}
        cssClass={`${parentStyles.searchInputContainer} ${isFocused && parentStyles.focused}`}
        iconCSS={`${parentStyles.iconCSS} ${isFocused && parentStyles.focused}`}
        inputCssClass={parentStyles.searchInput}
        buttonCssClass={`${parentStyles.buttonCssClass} ${isFocused && parentStyles.focused}`}
        handleFocus={handleSearchFocus}
        handleBlur={handleSearchBlur}
        handleKeyDown={handleSearchKeyDown}
        style='secondary'
      />
      <OrderByDropdown options={orderByOptions} selected={selectedOrder} handleOrderByChange={handleOrderByChange} />
    </div>
  )
}

export default Header
